import styled, { css } from 'styled-components';

import { Images } from 'assets/images';

const logoWidth = '166px';
const kodcentrumLogoWidth = '125px';
export const maxWidth = 990;
const mediaMaxWidth = `max-width: ${maxWidth}px`;
const mediaMinWidth = `min-width: ${maxWidth}px`;

export const FreecodeNav = styled.nav`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: flex-start;
  background: ${({ theme }) => theme.freecode.headerBackground};
  box-shadow: 0px 1px 0px 0px ${({ theme }) => theme.freecode.headerDropShadow};
  padding: 0px !important;
  height: 55px;
  position: fixed !important;
  top: 0 !important;
  width: 100% !important;
  z-index: 999;
  @media (${mediaMaxWidth}) {
    justify-content: space-between;
  }
`;

export const LinkSpacer = styled.span`
  margin-right: auto;
  @media (${mediaMaxWidth}) {
    display: none;
  }
`;

export const MenuIcon = styled.div`
  display: none;
  margin-right: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.pageHeader.icon.color};
  :after {
    content: '\f0c9';
    font-family: FontAwesome;
    font-size: 32px;
  }

  @media (${mediaMaxWidth}) {
    display: block;
  }
`;

export const NavbarContents = styled.div`
  display: flex;
  max-width: calc(100% - ${logoWidth});
  flex-basis: auto;
  flex-grow: 1;
  align-items: center;
  gap: 5px;
  background: ${({ theme }) => theme.freecode.headerBackground};
  padding-left: 8px;
  padding-right: 8px;
  z-index: 9;
  @media (${mediaMaxWidth}) {
    display: none;
  }

  ${(props) =>
    props.isKodcentrumCampaign &&
    css`
      max-width: calc(100% - ${kodcentrumLogoWidth});
    `}
`;

export const DropdownContent = styled.div`
  display: none;
  flex-direction: column;
  gap: 5px;
  position: absolute;
  top: 55px;
  width: 100%;
  padding-left: 5px;
  padding-bottom: 5px;
  background: ${({ theme }) => theme.freecode.headerBackground};
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.8);
  max-height: calc(100vh - 55px);
  overflow-y: auto;
  @media (${mediaMaxWidth}) {
    display: flex;
  }
`;

export const NavbarContentRow = styled.div`
  margin: 0px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 5px;
`;

export const ButtonContainer = styled.div`
  margin: 0px;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 1;
`;

export const LogoImg = styled.img.attrs(({ theme, isKodcentrumCampaign }) => ({
  src: isKodcentrumCampaign ? Images.kodcentrumLogo : theme.freecode.logo,
}))`
  width: ${logoWidth};
  cursor: pointer;
  padding-left: 12px;

  ${(props) =>
    props.isKodcentrumCampaign &&
    css`
      width: ${kodcentrumLogoWidth};
    `}
`;

export const LogoImgSmall = styled.img.attrs(({ theme, isKodcentrumCampaign }) => ({
  src: isKodcentrumCampaign ? Images.kodcentrumLogo : theme.freecode.logoSmall,
}))`
  height: 31px;
  cursor: pointer;
  padding-left: 15px;
`;

export const HeaderLink = styled.a`
  display: block;
  color: ${({ theme }) => theme.freecode.color};
  font-family: 'IBM Plex Sans', sans-serif;
  white-space: nowrap;
  letter-spacing: 1px;

  &:link {
    text-decoration: none;
  }
  &:visited {
    text-decoration: none;
  }
  &:hover {
    text-decoration: none !important;
    color: ${({ theme }) => theme.freecode.activeAreaColor};
  }
  &:active {
    text-decoration: none;
  }

  @media (${mediaMinWidth}) {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;

export const UserDetailsContainer = styled.div`
  display: flex;
  gap: 10px;
  @media (${mediaMaxWidth}) {
    flex-direction: row-reverse;
  }
`;

export const UserNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  letter-spacing: 1px;
`;

export const UserName = styled.h4`
  font-size: 16px;
  display: block;
  margin: 0px;
  color: ${({ theme }) => theme.freecode.color};
  font-family: 'IBM Plex Sans', sans-serif;
  white-space: nowrap;
  @media (${mediaMinWidth}) {
    text-align: right;
  }
`;

export const UserCompanyName = styled.h6`
  font-size: 12px;
  display: block;
  margin: 0px;
  color: ${({ theme }) => theme.freecode.color};
  font-family: 'IBM Plex Sans', sans-serif;
  white-space: nowrap;
  @media (${mediaMinWidth}) {
    text-align: right;
  }
`;

export const UserProfileImage = styled.img`
  border-radius: 50%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
  width: 35px;
  height: 35px;
  vertical-align: top;
  margin: 6px 0px;
`;

export const MidContainer = styled.span`
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 0px 15px;
`;

export const SponsorContainer = styled.span`
  overflow: hidden;
`;

export const SponsorDisclaimer = styled.p`
  color: ${({ theme }) => theme.freecode.color};
  margin: 0px;
  font-size: 10px;
`;

export const SponsorLink = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.freecode.color};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;

  &:link {
    color: ${({ theme }) => theme.freecode.color};
  }
  &:visited {
    color: ${({ theme }) => theme.freecode.color};
  }
  &:hover {
    color: ${({ theme }) => theme.freecode.color};
  }
  &:active {
    color: ${({ theme }) => theme.freecode.color};
  }
`;

export const SponsorLogoContainer = styled.span`
  display: flex;
  align-items: center;
  height: 55px;
  max-height: 55px;
  padding: 0px 5px;
  overflow: hidden;
`;

export const SponsorLogo = styled.img`
  max-width: 100%;
  max-height: 35px;
`;

export const ProgressRowContainer = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 55px;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;

export const ProgressBarAndTimeContainer = styled.span`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 55px;
  max-width: 100%;
  width: 250px;
  justify-content: center;
  align-items: center;
`;

export const ProgressTime = styled.span`
  color: ${({ theme }) => theme.freecode.color};
  font-size: 12px;
  white-space: nowrap;
  margin-bottom: 0px;
`;

export const LayoutOptionIcon = styled.i.attrs(({ icon }) => ({ className: icon }))`
  width: 20px;
  margin-right: 7px;
  text-align: center;
`;

// Made to somewhat match RoundIconButton
export const SpectateCountContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-wrap: nowrap;
  line-height: 0;
  min-height: 42px;
  min-width: 56px;
  border-radius: 1rem;
  background: ${({ theme }) => theme.freecode.buttonBackground};
  color: ${({ theme }) => theme.freecode.buttonColor};
  cursor: default;
  user-select: none;
  & i {
    font-size: 1rem;
  }
`;
